<template>
  <div id="sound-map">
    <soundMapPopup v-if="selectedObj"
                   :dataObj="selectedObj"
                   @close="closeDialog"></soundMapPopup>
    <div id="map"></div>
    <div class="title">
      <router-link to="/" class="arrow-back">
        <svg id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <polygon points="352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 "/>
        </svg>
      </router-link>
      <h1>Csepel hangtérkép</h1>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import arrowSvg from './../components/arrow.vue'

import soundMapPopup from './../components/soundMapPopup.vue'
export default {
  name: 'soundMap',
  components: { soundMapPopup, arrowSvg },
  props: {},
  data: function () {
    return {
      selectedObj: null,
      tileLayer: 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png',
      map: null,
    }
  },
  mounted () {
    if (this.$store.state.soundMap.mapDataLoaded) {
      this.initMap()
      this.initLayers()
    } else {
      this.$store.dispatch('soundMap/getMapData')
      this.initMap()
    }
  },
  computed: {
    mapData () {
      return this.$store.getters['soundMap/getMapData']
    }
  },
  watch: {
    mapData (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.initLayers()
      }
    }
  },
  methods: {
    openDialog (data) {
      this.selectedObj = data
    },
    closeDialog () {
      this.selectedObj = null
    },
    initMap () {
      this.map = L.map('map').setView([47.427, 19.056], 15.4)
      L.tileLayer(this.tileLayer, {
        maxZoom: 20,
        attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
      }).addTo(this.map)
    },
    initLayers () {
      this.mapData.forEach((data) => {
        const redIcon = new L.Icon({
          iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });

        const marker = data.type === 'NOISE' ? L.marker(data.coordinates, {icon: redIcon}) : L.marker(data.coordinates)

        data.leafletObject = marker.bindPopup(data.title)
        .on('mouseover', function () {
          this.openPopup()
        }).on('mouseout', function () {
          this.closePopup()
        }).on('click', (e) => {
          this.openDialog(data)
        }).addTo(this.map)
      })
    }
  }
}
</script>

<style scoped>
#sound-map {
  width: 100%;
  height: 100vh;
  position: relative;
}
#map {
  width: 100%;
  height: 100%;
}

  .title {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 60px;
    padding: 0 20px;
    z-index: 400;
    background: rgba(255, 255, 255, 0.4);
    box-sizing: border-box;
  }

  h1 {
    font-size: 18px;
    color: var(--colorB);
    margin-left: 30px;
    text-transform: uppercase;
  }

  .arrow-back {
    display: block;
    width: 40px;
    height: 40px;
    padding: 5px;
    font-size: 22px;
    color: var(--colorB);
    border: 2px solid var(--colorB);
    box-sizing: border-box;
  }

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  .leaflet-control-container .leaflet-top {
    top: 60px !important;
  }
</style>
